// Top bar rendered across every authenticated route.
// Left: BrandMenu (the "ArchLang Studio" wordmark — workspace switching,
//   Settings + sign out; workspace nav and account live in the Settings modal
//   the menu opens) and, within a workspace, a RepoSwitcher
//   for the active repository, followed by the header slots the active route and
//   active tab fill (the editor hoists its changeset header into the first; the
//   review tab hoists its view modes + lifecycle actions into the trailing one).

import { RepoSwitcher } from "./RepoSwitcher";
import { BrandMenu } from "./BrandMenu";
import { useHeaderSlotRef } from "./headerSlot";

interface TopBarProps {
  readonly activeSlug: string | null;
}

export function TopBar({ activeSlug }: TopBarProps) {
  const slotRef = useHeaderSlotRef("route");
  const tabSlotRef = useHeaderSlotRef("tab");

  return (
    <header className="flex h-11 shrink-0 items-center gap-2 border-b border-slate-800/80 bg-slate-950/80 px-3 backdrop-blur supports-backdrop-filter:bg-slate-950/60">
      <BrandMenu slug={activeSlug} />
      {activeSlug ? (
        <>
          <span className="h-5 w-px bg-slate-800" aria-hidden="true" />
          <RepoSwitcher />
        </>
      ) : null}
      {/* Route-filled slot (e.g. the editor's changeset header). */}
      <div ref={slotRef} className="flex min-w-0 flex-1 items-center gap-2" />
      {/* Active-tab chrome (e.g. the review tab's view modes + accept/archive). */}
      <div ref={tabSlotRef} className="flex shrink-0 items-center gap-2" />
    </header>
  );
}
